'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _addTimetokenToHistory = require('conversations-schema/thread-history/operators/addTimetokenToHistory');

var _getThreadId = require('conversations-schema/pubnub-message/operators/getThreadId');

var _buildMessageKey = require('conversations-schema/pubnub-message/operators/buildMessageKey');

var _ThreadHistory = require('conversations-schema/thread-history/ThreadHistory');

var _ThreadHistory2 = _interopRequireDefault(_ThreadHistory);

var _addPageOfMessagesToThreadHistory = require('conversations-schema/thread-history/operators/addPageOfMessagesToThreadHistory');

var _updateMessageInThreadHistory = require('conversations-schema/thread-history/operators/updateMessageInThreadHistory');

var _IndexedAsyncData = require('conversations-internal-schema/indexed-async-data/IndexedAsyncData');

var _IndexedAsyncData2 = _interopRequireDefault(_IndexedAsyncData);

var _updateEntry = require('conversations-internal-schema/indexed-async-data/operators/updateEntry');

var _setEntry = require('conversations-internal-schema/indexed-async-data/operators/setEntry');

var _AsyncData = require('conversations-internal-schema/async-data/AsyncData');

var _AsyncData2 = _interopRequireDefault(_AsyncData);

var _requestStarted = require('conversations-internal-schema/async-data/operators/requestStarted');

var _requestSucceededWithOperator = require('conversations-internal-schema/async-data/operators/requestSucceededWithOperator');

var _requestFailed = require('conversations-internal-schema/async-data/operators/requestFailed');

var _updateAsyncData = require('conversations-internal-schema/async-data/operators/updateAsyncData');

var _asyncStatuses = require('conversations-internal-schema/async-data/constants/asyncStatuses');

var _makeRequestActionTypes = require('conversations-internal-clients/action-creators/operators/makeRequestActionTypes');

var _ActionTypes = require('../constants/ActionTypes');

var _addMessageToThreadHistory = require('../operators/addMessageToThreadHistory');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _makeRequestActionTyp = (0, _makeRequestActionTypes.makeRequestActionTypes)(_ActionTypes.FETCH_THREAD_HISTORY),
    FETCH_THREAD_HISTORY_FAILED = _makeRequestActionTyp.FAILED,
    FETCH_THREAD_HISTORY_STARTED = _makeRequestActionTyp.STARTED,
    FETCH_THREAD_HISTORY_SUCCEEDED = _makeRequestActionTyp.SUCCEEDED;

var initialState = (0, _IndexedAsyncData2.default)({
  notSetValue: (0, _AsyncData2.default)({ data: new _ThreadHistory2.default() })
});

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, FETCH_THREAD_HISTORY_STARTED, function (state, action) {
  var requestArgs = action.payload.requestArgs;


  return (0, _updateEntry.updateEntry)(requestArgs.threadId, _requestStarted.requestStarted, state);
}), _defineProperty(_handleActions, FETCH_THREAD_HISTORY_SUCCEEDED, function (state, action) {
  var _action$payload = action.payload,
      requestArgs = _action$payload.requestArgs,
      newHistoryPage = _action$payload.data.threadHistory;


  return (0, _updateEntry.updateEntry)(requestArgs.threadId, (0, _requestSucceededWithOperator.requestSucceededWithOperator)((0, _addPageOfMessagesToThreadHistory.addPageOfMessagesToThreadHistory)(newHistoryPage)), state);
}), _defineProperty(_handleActions, FETCH_THREAD_HISTORY_FAILED, function (state, action) {
  var requestArgs = action.payload.requestArgs;


  return (0, _updateEntry.updateEntry)(requestArgs.threadId, _requestFailed.requestFailed, state);
}), _defineProperty(_handleActions, ActionTypes.OUTGOING_MESSAGE_TRANSMITTED, function (state, action) {
  var _action$payload2 = action.payload,
      message = _action$payload2.message,
      timetoken = _action$payload2.timetoken;


  var messageKey = (0, _buildMessageKey.buildMessageKey)(message);
  var threadId = (0, _getThreadId.getThreadId)(message);

  return (0, _updateEntry.updateEntry)(threadId, (0, _updateAsyncData.updateAsyncData)((0, _addTimetokenToHistory.addTimetokenToHistory)(messageKey, timetoken)), state);
}), _defineProperty(_handleActions, ActionTypes.ADD_MESSAGE_TO_CONVERSATION, function (state, action) {
  var message = action.payload.message;


  var messageKey = (0, _buildMessageKey.buildMessageKey)(message);
  var threadId = (0, _getThreadId.getThreadId)(message);

  return (0, _updateEntry.updateEntry)(threadId, (0, _updateAsyncData.updateAsyncData)((0, _addMessageToThreadHistory.addMessageToThreadHistory)(messageKey, message)), state);
}), _defineProperty(_handleActions, ActionTypes.UPDATE_MESSAGE_IN_CONVERSATION, function (state, action) {
  var _action$payload3 = action.payload,
      message = _action$payload3.message,
      updated = _action$payload3.updated;


  var threadId = (0, _getThreadId.getThreadId)(message);
  var messageKey = (0, _buildMessageKey.buildMessageKey)(message);

  return (0, _updateEntry.updateEntry)(threadId, (0, _updateAsyncData.updateAsyncData)((0, _updateMessageInThreadHistory.updateMessageInThreadHistory)(messageKey, updated)), state);
}), _defineProperty(_handleActions, ActionTypes.CREATE_VISITOR_THREAD_SUCCESS, function (state, action) {
  var threadId = (0, _getIn2.default)(['payload', 'threadId'], action);
  return (0, _setEntry.setEntry)(threadId, new _AsyncData2.default({ data: new _ThreadHistory2.default(), status: _asyncStatuses.SUCCEEDED }), state);
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/thread-histories/reducers/visitorThreadHistories.js
// module id = 881
// module chunks = 2 3